import types from './types';
import {
  searchProviders,
  getYears,
  providersFilterList,
  getAcademicYears as _getAcademicYears,
  getStatuses as _getStatus,
  getAdminFilters as _getAdminFilters,
  getMunicipalities as _getMunicipalities,
  save as _save,
  getCompanyTypes as _getCompanyTypes,
  proposalsCanBeAssignedToEvaluators as _getProposalsCanBeAssignedToEvaluators,
  previewProposalsAssignedToEvaluators as _getpreviewProposalsAssignedToEvaluators,
} from '../api';

export default {
  async searchProviders(context, filter) {
    const providers = await searchProviders(filter);
    context.commit(types.SET_PROVIDERS, providers);
  },
  async providersFilterList(context) {
    const providers = await providersFilterList();
    context.commit(types.SET_PROVIDERSLIST, providers);
  },
  async getStatuses(context) {
    if (context.state.statuses.length == 0) {
      const statuses = await _getStatus();
      context.commit(types.SET_STATUSES, statuses);
    }
  },

  async getProposalStatuses(context) {
    if (context.state.proposal.statuses.length == 0) {
      const statuses = await _getStatus();
      context.commit(types.SET_PROPOSAL_STATUSES, statuses);
    }
  },

  async getYears(context) {
    if (context.state.years.length == 0) {
      const years = await getYears();
      context.commit(types.SET_YEARS, years);
    }
  },

  async getAcademicYears(context) {
    if (context.state.proposal.academicYears.length == 0) {
      const academicYears = await _getAcademicYears();
      context.commit(types.SET_PROPOSAL_ACADEMICYEARS, academicYears.data);
    }
  },

  async getAdminFilter(context, academicYear) {
    if (
      context.state.proposal.areas.length == 0 ||
      context.state.proposal.evaluators == undefined ||
      context.state.proposal.evaluators.length == 0 ||
      context.state.proposal.providers.length == 0 ||
      context.state.proposal.statuses.length == 0
    ) {
      const response = await _getAdminFilters(academicYear);
      context.commit(types.SET_PROPOSAL_ACADEMICYEARS, response.AcademicYear);
      context.commit(
        types.SET_PROPOSAL_DEFAULTACADEMICYEAR,
        response.AcademicYear[0]
      );
      context.commit(types.SET_PROPOSAL_AREAS, response.Area);
      context.commit(types.SET_PROPOSAL_EVALUATORS, response.Evaluators);
      context.commit(types.SET_PROPOSAL_PROVIDERS, response.Companies);
      context.commit(types.SET_PROPOSAL_STATUSES, response.Statuses);
    }
  },

  async getMunicipalities(context) {
    if (context.state.municipalities.length == 0) {
      const municipalities = await _getMunicipalities();
      context.commit(types.SET_MUNICIPALITIES, municipalities);
    }
  },

  async save(_, data) {
    const response = await _save(data);
    return response;
  },

  async getCompanyTypes(context) {
    if (context.state.companyTypes.length == 0) {
      const companyTypes = await _getCompanyTypes();
      context.commit(types.SET_COMPANYTYPES, companyTypes);
    }
  },

  async getProposalsCanBeAssignedToEvaluators(context) {
    const response = await _getProposalsCanBeAssignedToEvaluators();
    const status = response.data;
    context.commit(types.SET_CAN_BE_ASSIGNED_TO_EVALUATORS, status);
  },

  async setFalseProposalsCanBeAssignedToEvaluators(context) {
    context.commit(types.SET_CAN_BE_ASSIGNED_TO_EVALUATORS, false);
  },

  async getpreviewProposalsAssignedToEvaluators(context) {
    const response = await _getpreviewProposalsAssignedToEvaluators();
    const previewList = response.data;
    context.commit(
      types.SET_PREVIEW_LIST_PROPOSAL_ASSIGNED_TO_EVALUATORS,
      previewList
    );
  },

  async setCompanySSN(context, ssn) {
    context.commit(types.SET_COMPANY_SSN, ssn);
  },
};
